import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICoordenadas } from 'modelos/src';

@Component({
  selector: 'app-ubicar',
  templateUrl: './ubicar.component.html',
  styleUrls: ['./ubicar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UbicarComponent {
  title = 'Ubicación';
  coordenadas: ICoordenadas;
  centro: [number, number];

  constructor(
    public dialogRef: MatDialogRef<UbicarComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      coordenadas: ICoordenadas;
      title: string;
      markerDraggable: boolean;
    },
  ) {
    this.title = this.data.title || this.title;
    this.coordenadas = this.data.coordenadas;
    this.centro = [this.data.coordenadas.lng, this.data.coordenadas.lat];
  }

  public close(): void {
    this.dialogRef.close();
  }

  public guardar(): void {
    this.dialogRef.close(this.coordenadas);
  }

  public onCoordenadaCambiada(coord: [number, number]): void {
    this.coordenadas = { lng: coord[0], lat: coord[1] };
  }
}
